// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__1sU1z","body":"styles_body__zpT6N","containerForm":"styles_containerForm__8+lnb"};